export default {
  nome: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  inactive: {
    value: null,
    required: false,
    state: null
  },
  paId: {
    value: null,
    required: false,
    state: null
  },
  standalone: {
    value: false,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/nxSenhas/categoria/components/add/categoria-form.js